// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import {defineStore} from 'pinia'

const MOBILE_BREAKPOINT = 992
const TABLET_BREAKPOINT = 992


export const useMobileViewStore = defineStore('MobileViewStore', {
  state: () => {
    return {
      isMobileView: window.innerWidth < MOBILE_BREAKPOINT,
      isTabletView: window.innerWidth >= MOBILE_BREAKPOINT && window.innerWidth < TABLET_BREAKPOINT,
    }
  },
  getters: {
    getIsMobileView(state) {
      return state.isMobileView
    }
    
  },
  actions: {
    updateIsMobileView() {
      this.isMobileView = window.innerWidth < MOBILE_BREAKPOINT;
      this.isTabletView = window.innerWidth >= MOBILE_BREAKPOINT && window.innerWidth < TABLET_BREAKPOINT;
    },
  },
})
